import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface LogoProps {
  /** Hides the wordmark, for the collapsed nav rail and mobile header. */
  markOnly?: boolean;
}

/**
 * Three stacked bars in the register colours — the product's whole idea as a
 * mark. The bars are decorative; the accessible name is the product name.
 */
export function Logo({ markOnly = false }: LogoProps) {
  return (
    <Stack direction="row" spacing={1.25} alignItems="center">
      <Stack aria-hidden spacing={0.5} sx={{ width: 22, flexShrink: 0 }} role="presentation">
        {(['good', 'bad', 'ideal'] as const).map((accent) => (
          <Box
            key={accent}
            sx={{
              height: 4,
              borderRadius: 999,
              backgroundColor: (theme) => theme.palette[accent].main,
              // Staggered widths so the mark reads as a mark, not a flag.
              width: accent === 'good' ? '100%' : accent === 'bad' ? '72%' : '86%',
            }}
          />
        ))}
      </Stack>

      {!markOnly && (
        <Typography
          component="span"
          sx={{
            fontWeight: 700,
            fontSize: '0.9375rem',
            letterSpacing: '-0.02em',
            whiteSpace: 'nowrap',
          }}
        >
          The Good, The Bad, The Ideal
        </Typography>
      )}
    </Stack>
  );
}
